/* Overskrifter utenfor hero: bokstavene rulles opp når overskriften kommer
 * til syne. Hero og «testland» styrer sine egne, og hoppes over her. */

import gsap from 'gsap';
import { $$, mindreBevegelse } from '../kjerne/verktoy.js';

export function startOverskrifter() {
  if (mindreBevegelse.matches) return;

  for (const el of $$('.oppdelt')) {
    if (el.closest('.hero') || el.closest('#testland')) continue;
    gsap.from(el.querySelectorAll('.tegn'), {
      yPercent: 130,
      duration: 1.1,
      ease: 'expo.out',
      stagger: .014,
      scrollTrigger: { trigger: el, start: 'top 88%' },
    });
  }
}
